import Api from '@/api';
import { Http } from '../../../utilities/util';

/**
 * @TODO remove when error envelope is put into effect (https://homegauge.atlassian.net/browse/WEB-4035)
 *
 * Convert legacy error to standard error envelope
 * @param {object} error
 * @returns {object} Standardized error envelope
 */
const convertLegacyError = error => {
  if (error.body) {
    return error;
  }

  const output = {
    success: false,
    body: {
      message: 'Payment could not be processed',
      fieldViolations: [],
    },
  };

  if (error.message) {
    output.body.message = error.message;
  }

  if (error.error) {
    const errorViolations = {
      field: 'error',
      messages: [],
    };
    if (error.error.exception) {
      errorViolations.messages.push(`${error.error.message} ${error.error.exception}`);
    }
    output.body.fieldViolations.push(errorViolations);

    const fieldViolations = error.error.constraintViolations;
    const fieldViolationsKeys = Object.keys(fieldViolations);
    fieldViolationsKeys.forEach(key => {
      output.body.fieldViolations.push({ field: key, messages: fieldViolations[key] });
    });
  }


  return output;
};

/*
 * Public Functions
*/
const makePayment = (context, paymentData) => new Promise((resolve, reject) => {
  Api.folderService.postInspectionPayment(paymentData.folderId, paymentData.payment)
    .then(response => {
      context.commit('setPaymentResponse', response.data);
      resolve(response.data);
    })
    .catch(error => {
      // redirect to classic if unauthenticated
      if (error.unauthenticatedError) {
        Api.authService.loginClassic(window.location.href);
      }

      const output = convertLegacyError(error.data);
      context.commit('setPaymentResponse', {});
      reject(output);
    });
});

const loadPayment = (context, folderId) => new Promise((resolve, reject) => {
  Api.folderService.getInspectionPayment(folderId)
    .then(response => {
      context.commit('setPaymentDefaults', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setPaymentDefaults', {});
      Http.setGlobalError(context, Http.createError(error, 'payment.actions.loadPayment', { folderId }));
      reject();
    });
});

const loadPaymentGateway = (context, folderId) => new Promise((resolve, reject) => {
  Api.folderService.getInspectionGatewayAccount(folderId)
    .then(response => {
      context.commit('setPaymentGateway', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setPaymentGateway', {});
      Http.setGlobalError(context, Http.createError(error, 'payment.actions.loadPaymentGateway', { folderId }));
      reject();
    });
});

export { convertLegacyError };
export default {
  makePayment,
  loadPayment,
  loadPaymentGateway,
};
